export default {
  infoBanner: {
    selectANewTime: 'Select a new time.',
  },
  atHomeNextSteps: 'We will call you momentarily to confirm a time window for your at-home visit.',
  bookingSummary: {
    bookIt: 'Book it',
    joinVideoVisit: 'Join video visit',
    continueWithRequest: 'Continue with request',
    title: 'Have you been to {{location_name}} before?',
    haveYouBeen: 'Have you been to this clinic before?',
    opaqueFinalizeCard: {
      followUpForYourChat:
        "Great. Now that we have your info, we'll follow up for your chat with a physician within the next hour.",
      findTheMostConvenientAppt:
        "Great. Now that we have your info, we'll find the most convenient appointment for you.",
    },
    cta: {
      noInsuranceSaved: "Looks like we don't have your insurance saved. Do you want to add it?",
      justConfirmAppointment: 'Just confirm visit',
      addInsurance: 'Add insurance',
      thisClinicIsSelfPayOnly: 'This clinic is self-pay only',
      continue: 'Continue',
      book: 'Book',
      confirm: 'Confirm',
      lastVisitCashPay: 'For your last visit, you chose to pay cash.',
      payCashAgain: 'Pay cash again',
      thisTimeUsingInsurance: "This time I'm using insurance",
      useItAgain: 'Use it again',
      useDifferentInsurance: 'Use different insurance',
      itsAMatch: "It's a match! We'd say this is the best urgent care visit for you.",
      seeMoreOptions: 'See more options',
      forTheLastVisitYouUsedYourInsurance:
        'For your last visit, you used your {{insurer_name}} insurance.',
      forTheLastVisitYouUsedYourPlan: 'For your last visit, you used your {{insurer_type}} plan.',
      confirmAppointment: 'Confirm appointment',
    },
    summaryHeader: {
      finalizeVisit: 'Finalize Your Visit',
      finalizeRequest: 'Finalize Your Request',
    },
  },
  callToBook: 'Call to Book',
  errorMessage: {
    anErrorOccuredPleaseCallOffice:
      'An error occurred while trying to book your visit. Please call the office at',
    sorrySlotNoLongerAvailableCovid:
      'Sorry, the time you selected is no longer available. We’re experiencing increased demand due to covid.',
    sorryTimeNoLongerAvailable: 'Sorry, the time you selected is no longer available. ',
    dueToHighDemandAllApptsAreBooked:
      'Due to high demand all of our appointments are booked for today. Please check back tomorrow.',
  },
};
